module.exports = __webpack_public_path__ + "static/img/brid_native.11a9bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/brid_native.png
// module id = 3h+W
// module chunks = 1 3